import './App.css';
import Home from "./pages/home"
function App() {
  return (
    <div className="App">
     <Home/>
    </div>
  );
}
//"author":"md Rashed Afridi"
export default App;
